var wishListHandler = {};
if (window.location.href.endsWith("all/")) {
  setTimeout(() => {
    [...document.querySelectorAll("wish-list")].forEach(elem => {
      elem.classList.add("wish-list");
      elem.tagName = "div";
    })
  }, 1000);
}
function toggleWishListItem() {
  var whBtn = this;
  var handler = this.dataset.api
  wishlistHandleBodyClick()
  handle_wishlist_item_click(handler, whBtn);
}
function update_wishlist_events() {
  jQuery('.boost-pfs-filter-product-item .brator-wish-list-custom').off('click', toggleWishListItem);
  jQuery('.boost-pfs-filter-product-item .brator-wish-list-custom').on('click', toggleWishListItem);
  console.log("Subscribed to .boost-pfs-filter-product-item .brator-wish-list-custom click")
}
function wishlistHandleBodyClick() {
  var wplLide = document.querySelector('.wpl-area')
  wplLide.classList.remove('active')
}
function render_wishlist_tile(data) {
  var wplLide = document.querySelector('.wpl-area')
  wplLide.innerHTML = ''
  wplLide.innerHTML += `
  <p class="tostare__heading">
  <svg class="icon icon-checkmark color-foreground-text" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
   <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path> 
  </svg> Item added to your wish List</p>
  <div class="brator-product-wpl-area">
    <div class="brator-product-single-item-img"> 
      <a href="${data.url}"> 
        <img src="${data.featured_image}" alt="${data.title}" loading="lazy" class="motion-reduce" width="925" height="617">
      </a> 
    </div> 
    <div class="brator-product-single-item-mini wishlist-tile-product-info-js">
      <div class="brator-product-single-item-title"> 
        <h5><a href="${data.url}"> ${data.title}</a></h5> 
      </div>
    </div> 
  </div>`
  wplLide.classList.add('animate', 'active')

  setTimeout(() => {
    wplLide.classList.remove('active');
  }, 4000);
}
/* 
      let handler = this.dataset.api
      var wplDwar = document.querySelector('.wpl-dwar')
      this.onBodyClick()
      var wishListElement = this;
       */
function handle_wishlist_item_click(handler, whBtn) {

  var wplDwar = document.querySelector('.wpl-dwar')
  axios.get(`/products/${handler}.js`)
    .then(
      response => {
        let wPl = (JSON.parse(localStorage.getItem('wPl')))

        if (wPl != null) {
          let oldNewFind = wPl.find(item => item.id === response.data.id)

          if (oldNewFind != undefined) {
            let newlishWish = []
            wPl.forEach(
              (product, index) => {
                if (product.id === response.data.id) {
                  newlishWish = wPl.filter(productItem => productItem.id !== response.data.id)
                  whBtn.classList.remove('active')
                  localStorage.setItem('wPl', JSON.stringify(newlishWish))
                  let wishStoreItemCount = wPl.length > 0
                  wishStoreItemCount ? document.querySelector('.wish-list-count').textContent = wPl.length - 1 : document.querySelector('.wish-list-count').textContent = 0
                }


              }
            )
            wplDwar.innerHTML = ""
            newlishWish.forEach(
              (product, index) => {
                wplDwar.innerHTML += `
                <div class="brator-product-wpl-area">
                  <div class="brator-product-single-item-img"> 
                    <a href="${product.url}"> 
                      <img src="${product.featured_image}" alt="${product.title}" loading="lazy" class="motion-reduce" width="925" height="617"> 
                    </a> 
                  </div> 
                  <div class="brator-product-single-item-mini newwishlist-tile-product-info-js"> 
                    <div class="brator-product-single-item-title"> 
                      <h5><a href="${product.url}"> ${product.title}</a></h5>
                      <wish-list class="wish-list" data-api="${product.handle}"> 
                        <button id="wish-${product.handle}" class="brator-wish-list-custom"> Remove </button>
                      </wish-list>
                    </div>
                  </div>
                </div>`
              }
            )

            let allProductItemLoppWish = document.querySelectorAll('.brator-wish-list-custom')

            if (allProductItemLoppWish.length > 0) {
              allProductItemLoppWish.forEach(
                (product, index) => {
                  if (product.id === `wish-${handler}`) {
                    let getAllPo = document.querySelectorAll('#' + product.id)
                    getAllPo.forEach(
                      (productI) => {
                        productI.classList.remove('active')
                      }
                    )
                  }
                }
              )
            }

            if (newlishWish.length == 0) {

              document.body.classList.add('no-wish-product-link')
            }
            if (newlishWish.length > 0) {

              document.body.classList.remove('no-wish-product-link')
            }

          } else {
            wPl.push(response.data)
            localStorage.setItem('wPl', JSON.stringify(wPl))
            render_wishlist_tile(response.data)
            let holeProduct = document.querySelectorAll('.wish-list')
            holeProduct.forEach(
              (product, index) => {
                if (product.querySelector('button').getAttribute('id') === `wish-${handler}`) {
                  product.querySelector('button').classList.add('active')
                }
              }
            )
            let wishStoreItemCount = wPl.length > 0
            wishStoreItemCount ? document.querySelector('.wish-list-count').textContent = wPl.length : document.querySelector('.wish-list-count').textContent = 0

            let wishStore = (JSON.parse(localStorage.getItem('wPl'))) ? (JSON.parse(localStorage.getItem('wPl'))) : []

            wishStore.forEach(
              (product, index) => {
                if (product.handle === handler) {
                  wplDwar.innerHTML += `
                  <div class="brator-product-wpl-area">
                    <div class="brator-product-single-item-img"> 
                      <a href="${product.url}"> 
                        <img src="${product.featured_image}" alt="${product.title}" loading="lazy" class="motion-reduce" width="925" height="617"> 
                      </a> 
                    </div> 
                    <div class="brator-product-single-item-mini wishstore-tile-product-info-js"> 
                      <div class="brator-product-single-item-title"> 
                        <h5><a href="${product.url}"> ${product.title}</a></h5>
                        <wish-list class="wish-list" data-api="${product.handle}"> 
                          <button id="wish-${product.handle}" class="brator-wish-list-custom"> Remove </button> 
                        </wish-list>
                      </div> 
                    </div> 
                  </div>`
                }
              }
            )
            if (wishStore.length == 0) {

              document.body.classList.add('no-wish-product-link')
            }
            if (wishStore.length > 0) {

              document.body.classList.remove('no-wish-product-link')
            }
          }
        } else {
          wPl = []
          wPl.push(response.data)
          localStorage.setItem('wPl', JSON.stringify(wPl))
          render_wishlist_tile(response.data)

          let holeProduct = document.querySelectorAll('.wish-list')
          holeProduct.forEach(
            (product, index) => {
              if (product.querySelector('button').getAttribute('id') === `wish-${handler}`) {
                product.querySelector('button').classList.add('active')
              }
            }
          )

          let wishStoreItemCount = wPl.length > 0
          wishStoreItemCount ? document.querySelector('.wish-list-count').textContent = wPl.length : document.querySelector('.wish-list-count').textContent = 0


          let wishStore = (JSON.parse(localStorage.getItem('wPl'))) ? (JSON.parse(localStorage.getItem('wPl'))) : []

          wishStore.forEach(
            (product, index) => {
              if (product.handle === handler) {
                wplDwar.innerHTML += `
                <div class="brator-product-wpl-area">
                  <div class="brator-product-single-item-img">
                    <a href="${product.url}"> 
                      <img src="${product.featured_image}" alt="${product.title}" loading="lazy" class="motion-reduce" width="925" height="617"> 
                    </a> 
                  </div> 
                  <div class="brator-product-single-item-mini wishstore-tile-product-info-js"> 
                    <div class="brator-product-single-item-title"> 
                      <h5><a href="${product.url}"> ${product.title}</a></h5>
                      <wish-list class="wish-list" data-api="${product.handle}"> 
                        <button id="wish-${product.handle}" class="brator-wish-list-custom"> Remove </button> 
                      </wish-list>
                    </div> 
                  </div> 
                </div>`
              }
            }
          )

          if (wishStore.length == 0) {
            document.body.classList.add('no-wish-product-link')
          }
          if (wishStore.length > 0) {
            document.body.classList.remove('no-wish-product-link')
          }
        }

      }
    )
    .catch(function (error) {
      console.log(error)
    })
    .finally(() => {

    })
}
function wishlist_render(handler, whBtn) {
  let wishStore = (JSON.parse(localStorage.getItem('wPl'))) ? (JSON.parse(localStorage.getItem('wPl'))) : []
  wishStore.forEach(
    (product, index) => {
      if (product.handle === handler) {
        whBtn.classList.add('active')
      }
    }
  )

  let wishStoreCount = wishStore.length > 0
  wishStoreCount ? document.querySelector('.wish-list-count').textContent = wishStore.length : document.querySelector('.wish-list-count').textContent = 0


  if (wishStore.length == 0) {
    document.body.classList.add('no-wish-product-link')
  }
  if (wishStore.length > 0) {
    document.body.classList.remove('no-wish-product-link')
  }
}
document.body.addEventListener('click', wishlistHandleBodyClick)
if (!customElements.get('wish-list')) {
  console.log("wish-list items not found creating");
  customElements.define('wish-list', class WishList extends HTMLElement {

    constructor() {
      super()
      this.whBtn = this.querySelector('.brator-wish-list-custom')
      this.nptxt = document.querySelector('.no-product-fount-wish')
      this.whBtn.addEventListener('click', this.WhListHandelar.bind(this))
      this.wishStoreRender()
    }

    wishStoreRender() {
      wishlist_render(this.dataset.api, this.whBtn);
    }
    WhListHandelar() {
      wishlistHandleBodyClick()
      handle_wishlist_item_click(this.dataset.api, this.whBtn);
    }
  }
  )
} else {
  console.log("wish-list items  found");
}

if (!customElements.get('compa-list')) {
  customElements.define('compa-list', class ComPa extends HTMLElement {

    constructor() {
      super()
      this.incdec = this.querySelector('.compa-incdec')
      this.incdec.addEventListener('click', this.incdecHandeler.bind(this))
      this.onBodyClick = this.handleBodyClick.bind(this)
      document.body.addEventListener('click', this.onBodyClick)

      this.compaInit()
    }

    compaInit() {

      let airStore = (JSON.parse(localStorage.getItem('compa'))) ? (JSON.parse(localStorage.getItem('compa'))) : []
      airStore.length > 0 ? document.querySelector('.compa-list-count').textContent = airStore.length : document.querySelector('.compa-list-count').textContent = 0
      let handler = this.dataset.api
      airStore.forEach(
        (product, index) => {
          if (product.handle === handler) {
            this.incdec.classList.add('active')
          }
        }
      )

      if (airStore.length == 0) {
        document.body.classList.add('no-compare-product-link')
      }
      if (airStore.length > 0) {
        document.body.classList.remove('no-compare-product-link')
      }


    }

    incdecHandeler() {

      let allDataSingle = this.dataset.api

      axios.get(`/products/${allDataSingle}.js`)
        .then(response => {

          let compalocal = JSON.parse(localStorage.getItem('compa'))
          if (compalocal != null) {

            let oNf = compalocal.find(item => item.id === response.data.id)
            if (oNf != undefined) {

              let newArray = compalocal.filter(item => item.id !== response.data.id)

              localStorage.setItem('compa', JSON.stringify(newArray))
              document.querySelector('.compa-list-count').textContent = newArray.length

              this.incdec.classList.remove('active')

              this.productList(newArray, allDataSingle)

              let incdecAll = document.querySelectorAll('.compa-incdec')
              incdecAll.forEach(
                (product, index) => {
                  if (product.getAttribute('id') === `btn-${allDataSingle}`) {
                    product.classList.remove('active')
                  }
                }
              )

              if (newArray.length == 0) {
                document.body.classList.add('no-compare-product-link')
              }
              if (newArray.length > 0) {
                document.body.classList.remove('no-compare-product-link')
              }

            }
            else {
              compalocal.push(response.data)
              localStorage.setItem('compa', JSON.stringify(compalocal))
              document.querySelector('.compa-list-count').textContent = compalocal.length
              this.tile(response.data)

              let incdecAll = document.querySelectorAll('.compa-incdec')
              incdecAll.forEach(
                (product, index) => {
                  if (product.getAttribute('id') === `btn-${allDataSingle}`) {
                    product.classList.add('active')
                  }
                }
              )

              this.productIn(compalocal, allDataSingle)
              let airStore = (JSON.parse(localStorage.getItem('compa'))) ? (JSON.parse(localStorage.getItem('compa'))) : []
              if (airStore.length == 0) {
                document.body.classList.add('no-compare-product-link')
              }
              if (airStore.length > 0) {
                document.body.classList.remove('no-compare-product-link')
              }
            }


          } else {

            compalocal = []
            compalocal.push(response.data)
            localStorage.setItem('compa', JSON.stringify(compalocal))
            compalocal.length > 0 ? document.querySelector('.compa-list-count').textContent = compalocal.length : document.querySelector('.compa-list-count').textContent = 0
            this.tile(response.data)

            let incdecAll = document.querySelectorAll('.compa-incdec')
            incdecAll.forEach(
              (product, index) => {
                if (product.getAttribute('id') === `btn-${allDataSingle}`) {
                  product.classList.add('active')
                }
              }
            )


            this.productIn(compalocal, allDataSingle)


            let airStore = (JSON.parse(localStorage.getItem('compa'))) ? (JSON.parse(localStorage.getItem('compa'))) : []
            if (airStore.length == 0) {
              document.body.classList.add('no-compare-product-link')
            }
            if (airStore.length > 0) {
              document.body.classList.remove('no-compare-product-link')
            }


          }



        })
        .catch(function (error) {
          // handle error
          console.log(error)
        })
        .then(function () {
        })

    }
    tile(data) {
      let compaArea = document.querySelector('.compa-notify')
      compaArea.innerHTML = ''
      compaArea.innerHTML += `
      <div class="brator-product-compa-area">
        <div class="brator-product-single-item-img"> 
          <a href="${data.url}"> <img src="${data.featured_image}" alt="${data.title}" loading="lazy" class="motion-reduce" width="925" height="617"> </a>
        </div> 
        <div class="brator-product-single-item-mini compaarea-tile-product-info-js"> 
          <div class="brator-product-single-item-title"> 
            <h5><a href="${data.url}"> ${data.title}</a></h5> 
          </div> 
        </div> 
      </div>`

      let compaAreaN = document.querySelector('.compa-area')
      compaAreaN.classList.add('animate', 'active')

    }

    handleBodyClick() {
      let compaAreaN = document.querySelector('.compa-area')
      compaAreaN.classList.remove('active')
    }

    productIn(data, handler) {
      var compaDwar = document.querySelector('.compa-dwar')
      data.forEach(
        (product, index) => {
          if (product.handle === handler) {
            compaDwar.innerHTML += `
            <div class="brator-product-single-item-area splide__slide design-two"> 
              <div class="brator-compare-product-content"> 
                <div class="brator-product-single-item-info info-content-flex"> 
                  <div class="brator-product-single-item-info-right">
                    <compa-list class="compa-incdec-area" data-api="${product.handle}"> 
                      <button id="btn-${product.handle}" class="compa-incdec active">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"> 
                          <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"></path> 
                          <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"></path> 
                        </svg> 
                      </button> 
                    </compa-list>
                  </div> 
                  <div class="brator-product-single-item-info-left"> 
                    <div class="off-batch">20% OFF</div> 
                  </div> 
                </div> 
                <div class="brator-product-single-item-img">
                  <a href="${product.url}"><img src="${product.featured_image}" alt="${product.title}"/></a>
                </div> 
                <div class="brator-product-single-item-mini productin-compadwar-tile-product-info-js">
                  <div class="brator-product-single-item-cat">
                    <a href="product-layout-01.html">Brakepro</a>
                  </div> 
                  <div class="brator-product-single-item-title"> 
                    <h5><a href="${product.url}">${product.title}</a></h5> 
                  </div> 
                  <div class="brator-product-single-item-price"> 
                    <p><sub>$172.96</sub><b class="pub">$100</b></p> 
                  </div> 
                </div> 
              </div> 
              <div class="brator-compare-product-info"> 
                <div class="brator-compare-info-list"><p>Short unique description</p></div> 
                <div class="brator-compare-info-list"><p>Guess</p></div> 
                <div class="brator-compare-info-list"><p>White</p></div> 
                <div class="brator-compare-info-list"><p>Included Tax</p></div>
                <div class="brator-compare-info-list"><p>-</p></div>
              </div>
            </div>`
          }
        }
      )
    }

    productList(data, handler) {
      var compaDwar = document.querySelector('.compa-dwar')
      compaDwar.innerHTML = ""
      data.forEach(
        (product, index) => {
          compaDwar.innerHTML += `
          <div class="brator-product-single-item-area splide__slide design-two"> 
            <div class="brator-compare-product-content"> 
              <div class="brator-product-single-item-info info-content-flex"> 
                <div class="brator-product-single-item-info-right">
                  <compa-list class="compa-incdec-area" data-api="${product.handle}"> 
                    <button id="btn-${product.handle}" class="compa-incdec active">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"> 
                        <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"></path> 
                        <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"></path> 
                      </svg>
                    </button> 
                  </compa-list>
                </div> 
                <div class="brator-product-single-item-info-left"> 
                  <div class="off-batch">20% OFF</div> 
                </div> 
              </div> 
              <div class="brator-product-single-item-img">
                <a href="${product.url}"><img src="${product.featured_image}" alt="${product.title}"/></a>
              </div> 
              <div class="brator-product-single-item-mini productlist-compadwar-tile-product-info-js"> 
                <div class="brator-product-single-item-cat"><a href="product-layout-01.html">Brakepro</a></div> 
                <div class="brator-product-single-item-title"> <h5><a href="${product.url}">${product.title}</a></h5> </div> 
                <div class="brator-product-single-item-price"> <p><sub>$172.96</sub><b class="pub">$100</b></p> </div> 
              </div> 
            </div> 
            <div class="brator-compare-product-info"> 
              <div class="brator-compare-info-list"> <p>Short unique description</p> </div> 
              <div class="brator-compare-info-list"> <p>Guess</p> </div> 
              <div class="brator-compare-info-list"> <p>White</p> </div> 
              <div class="brator-compare-info-list"> <p>Included Tax</p> </div> 
              <div class="brator-compare-info-list"> <p>-</p> </div> 
            </div> 
          </div>`
        }
      )
    }

  })
}
